
import React from 'react';

const ReporteFilters = ({ 
    selectedReport, 
    onReportChange,
    selectedDate,
    onDateChange,
    fechaInicio,
    onFechaInicioChange,
    fechaFin,
    onFechaFinChange,
    tipoReporte,
    onTipoReporteChange,
    onGenerate
}) => {
    return (
        <form onSubmit={(e) => { e.preventDefault(); onGenerate(); }} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Generar Reportes</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 align-end items-end">
                {/* Tipo de Reporte */}
                <div className="col-span-1 lg:col-span-1">
                    <label htmlFor="reportType" className="block text-sm font-medium text-gray-700 mb-1">
                        Tipo de Reporte
                    </label>
                    <select
                        id="reportType"
                        className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
                        value={selectedReport}
                        onChange={onReportChange}
                    >
                        <option value="">-- Selecciona --</option>
                        <option value="medidores">Listado de Medidores</option>
                        <option value="clientes">Listado de Clientes</option>
                        <option value="suma-total">Consumos Mensuales (Por Fecha)</option>
                        <option value="reporte-rango">Rendición de Cuentas (Rango)</option>
                        <option value="morosos">Clientes Deudores</option>
                    </select>
                </div>

                {/* Filtros dinámicos */}
                {(selectedReport === "suma-total") && (
                    <div className="col-span-1">
                        <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
                            Fecha de Cobro
                        </label>
                        <input
                            type="date"
                            id="date"
                            className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
                            value={selectedDate}
                            onChange={onDateChange}
                        />
                    </div>
                )}

                {selectedReport === "reporte-rango" && (
                    <>
                        <div className="col-span-1">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Agrupación</label>
                            <select
                                className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
                                value={tipoReporte}
                                onChange={onTipoReporteChange}
                            >
                                <option value="dia">Por Día</option>
                                <option value="mes">Por Mes</option>
                            </select>
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="fechaInicio" className="block text-sm font-medium text-gray-700 mb-1">Desde</label>
                            <input
                                type="date"
                                id="fechaInicio"
                                className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
                                value={fechaInicio}
                                onChange={onFechaInicioChange}
                            />
                        </div>
                        <div className="col-span-1">
                            <label htmlFor="fechaFin" className="block text-sm font-medium text-gray-700 mb-1">Hasta</label>
                            <input
                                type="date"
                                id="fechaFin"
                                className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-3 py-2 border"
                                value={fechaFin}
                                onChange={onFechaFinChange}
                            />
                        </div>
                    </>
                )}

                {/* Botón Generar (siempre visible si hay reporte seleccionado, o condicional) */}
                <div className="col-span-1 lg:col-span-1">
                     <button
                        type="submit"
                        className="w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={!selectedReport}
                    >
                        Generar Vista Previa
                    </button>
                </div>
            </div>
        </form>
    );
};

export default ReporteFilters;
